import tooltipImg from 'img/tooltip/link-vigbo.png';
import React, { type FC } from 'react';
import { useNavigate } from 'react-router';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { type ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';

import styles from './LinkVigboTooltip.css';

interface Props {
    target: React.RefObject<HTMLElement> | null;
    title: string;
    text: string;
    buttonText: string;
    placement: ETooltipPlacement;
    usePortal?: boolean;
    onShow?: () => void;
    onClick?: () => void;
    onClose?: () => void;
    onCrossClose?: () => void;
}

export const LinkVigboTooltip: FC<Props> = ({
    target,
    title,
    text,
    usePortal,
    placement,
    onClick,
    onClose,
    onShow,
    onCrossClose,
    buttonText,
}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/vigbo');
        onClick?.();
    };

    return (
        <FloatingTooltip
            target={target}
            placement={placement}
            size={ETooltipSize.fit}
            closeOnOutsideClick={false}
            onClose={onClose}
            onShow={onShow}
            onCrossClose={onCrossClose}
            usePortal={usePortal}
            qaId="link-vigbo"
        >
            <div className={styles.root}>
                <div className={styles.textBlock}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.text}>{text}</div>
                </div>
                <Button onClick={handleClick} className={styles.button} primary theme="vk" sizeMode={ButtonSizeMode.small}>
                    {buttonText}
                </Button>
                <img className={styles.image} src={tooltipImg} alt="Картинка в тултипе" />
            </div>
        </FloatingTooltip>
    );
};
